<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/account.svg" alt=""></div>
            <div><h4 class="text-semibold">{{data.mode === 'edit' ? "Modificar informaci&oacute;n cuenta" : "Nueva cuenta"}}</h4><h6 class="color-gray" style="font-weight: 400;">{{data.mode === 'edit' ? "Completa los datos que necesitas modificar de la cuenta" : "Completa los datos para registrar una nueva cuenta"}}</h6></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <h5 class="text-semibold mt-4">Informaci&oacute;n de la cuenta</h5>
            <form #accountForm="ngForm" (ngSubmit)="$event.preventDefault()">
            <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                <div>
                    <div class="mt-3">
                        <label class="login-label" for="name"><span class="required-asterisk" *ngIf="!request.nombre_empresa || request.nombre_empresa.trim() === ''">*</span> Nombre de la cuenta:</label>
                        <input class="crm-input" type="text" name="name" id="name" [value]="cuenta?.nombre_empresa" [(ngModel)]="request.nombre_empresa" #nameCtrl="ngModel" placeholder="Siroe" required />
                          <div class="error-text" *ngIf="nameCtrl.invalid && nameCtrl.touched">
                            <small *ngIf="nameCtrl.errors?.['required']">Este campo es obligatorio.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="divisa"><span class="required-asterisk" *ngIf="!request.divisa_cuenta|| request.divisa_cuenta.trim() === ''">*</span> Divisa de la cuenta:</label>
                        <select class="crm-input" name="divisa" id="divisa" [(ngModel)]="request.divisa_cuenta" #divisaCtrl="ngModel" required>
                            <option value="" disabled selected>Seleccionar divisa de la cuenta</option>
                            <option value="CLP">CLP</option>
                            <option value="USD">USD</option>
                            <option value="EUR">EUR</option>
                        </select>
                    <div class="error-text" *ngIf="divisaCtrl.invalid && (divisaCtrl.dirty || divisaCtrl.touched)">
                    <small *ngIf="divisaCtrl.errors?.['required']">Debe seleccionar una divisa.</small>
                    </div>
                    </div>
                </div>
                <div>
                    <div class="mt-3">
                        <label class="login-label" for="rut"><span class="required-asterisk" *ngIf="!request.rut || request.rut.trim() === ''">*</span> RUT:</label>
                        <input class="crm-input" type="text" name="rut" id="rut" [value]="cuenta?.rut" [(ngModel)]="request.rut" placeholder="77.123.456-7" required #rutCtrl="ngModel"   pattern="^(\d{1,2}\.?\d{3}\.?\d{3}-[\dkK])$" title="Ingrese un RUT válido. Ejemplo: 12.345.678-9" />
                        <div class="error-text" *ngIf="rutCtrl.invalid && (rutCtrl.dirty || rutCtrl.touched)">
                        <small *ngIf="rutCtrl.errors?.['required']">El RUT es obligatorio.</small>
                        <small *ngIf="rutCtrl.errors?.['pattern']">El formato del RUT no es válido.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="telefono"><span class="required-asterisk" *ngIf="!request.telefono || request.telefono.trim() === ''">*</span>Teléfono:</label>
                        <input class="crm-input" type="text" name="telefono" id="telefono" [value]="cuenta?.telefono" [(ngModel)]="request.telefono" placeholder="+56 2 2134 5678" #telefonoCtrl="ngModel" required pattern="^\+?\d{0,15}$" inputmode="numeric" title="Ingrese solo números. Ejemplo: +56912345678" />
                        <div class="error-text" *ngIf="telefonoCtrl.invalid && (telefonoCtrl.dirty || telefonoCtrl.touched)">
                        <small *ngIf="telefonoCtrl.errors?.['required']">El teléfono es obligatorio.</small>
                        <small *ngIf="telefonoCtrl.errors?.['pattern']">Ingrese un número de teléfono válido.</small>
                        </div>
                    </div>
                </div>
            </div>
           <div class="mt-3">
            <label class="login-label" for="propietario">Propietario de la cuenta:</label>
            <div class="d-flex flex-row align-items-center color-org gap-10">
                <img src="assets/svg/avatar.svg" alt="">
                <b><u>
                {{ data.mode === 'edit'
                    ? (cuenta?.ejecutivo?.nombre + ' ' + cuenta?.ejecutivo?.apellido)
                    : accountOwnerName }}
                </u></b>
            </div>
            </div>

            <h5 class="text-semibold mt-4">Informaci&oacute;n adicional</h5>
            <div class="d-grid prospect-form" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                <div>
                    <div class="mt-3">
                        <label for="industria" class="login-label"><span class="required-asterisk" *ngIf="!request.industria_id|| request.industria_id.trim() === ''">*</span>Industria:</label>
                        <select class="crm-input" name="industria" id="industria" [(ngModel)]="request.industria_id" #industriaCtrl="ngModel" required>
                            <option value="" disabled selected>Seleccionar tipo de industria</option>
                            @for (industria of industrias; track industria) {
                                <option [value]="industria.industria_id" [selected]="cuenta?.industria_id === industria.industria_id">{{ industria.nombre }}</option>
                            }
                        </select>
                        <div class="error-text" *ngIf="industriaCtrl.invalid && (industriaCtrl.dirty || industriaCtrl.touched)">
                            <small *ngIf="industriaCtrl.errors?.['required']">Debe seleccionar una industria.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label for="website" class="login-label"><span class="required-asterisk" *ngIf="!request.sitio_web|| request.sitio_web.trim() === ''">*</span>Sitio web:</label>
                        <input class="crm-input" type="text" name="website" id="website" placeholder="www.siroe.cl" [value]="cuenta?.sitio_web" #sitwebCtrl="ngModel" [(ngModel)]="request.sitio_web" required>
                        <div class="error-text" *ngIf="sitwebCtrl.invalid && (sitwebCtrl.dirty || sitwebCtrl.touched)">
                            <small *ngIf="sitwebCtrl.errors?.['required']">El sitio web es obligatorio.</small>
                        </div>

                    </div>
                    <div class="mt-3">
                        <label for="linkedin" class="login-label">Linkedin empresa:</label>
                        <input class="crm-input" type="text" name="linkedin" id="linkedin" placeholder="Chile" [value]="cuenta?.linkedin" #linkeCtrl="ngModel" [(ngModel)]="request.linkedin">
                    </div>
                </div>
                <div>
                    <div class="mt-3">
                        <label for="empleados" class="login-label"><span class="required-asterisk" *ngIf="!request.empleados">*</span>Cantidad empleados:</label>
                        <input class="crm-input" type="number" min="0" name="empleados" id="empleados" placeholder="50" [value]="request.empleados" #empleadosCtrl="ngModel" [(ngModel)]="request.empleados" required>
                        <div class="error-text" *ngIf="empleadosCtrl.invalid && (empleadosCtrl.dirty || empleadosCtrl.touched)">
                            <small *ngIf="empleadosCtrl.errors?.['required']">La cantidad de empleados es obligatoria.</small>
                            <small *ngIf="empleadosCtrl.errors?.['min']">La cantidad de empleados no puede ser negativa.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label for="descripcion" class="login-label">Descripci&oacute;n</label>
                        <input class="crm-input" name="descripcion" id="descripcion" rows="4" placeholder="Agrega descripción de la cuenta (opcional)" #descripcionCtrl="ngModel" [(ngModel)]="request.descripcion">
                        
                    </div>
                </div>
            </div>

            <!-- <h5 class="text-semibold mt-4">Informaci&oacute;n de direcci&oacute;n</h5>
            <div class="mt-3">
                <label class="login-label" for="direccion_fact">B&uacute;squeda de la direcci&oacute;n:</label>
                <input class="crm-input" type="text" name="direccion_fact" id="direccion_fact" [value]="cuenta?.direccion_fact" [(ngModel)]="request.direccion_fact">
            </div> -->

            <div class="d-grid prospect-form mt-3" style="grid-template-columns: 1fr 1fr; column-gap: 32px;">
                <div>
                    <h5 class="text-semibold mt-4">Dirección de facturación</h5>
                    <div class="mt-3">
                        <label class="login-label" for="calle_fact"><span class="required-asterisk" *ngIf="!request.calle_fact|| request.calle_fact.trim() === ''">*</span>Calle:</label>
                        <input class="crm-input" type="text" name="calle_fact" id="calle_fact" [(ngModel)]="request.calle_fact" #calleFactCtrl="ngModel" placeholder="Av. Libertador 1234" required>
                        <div class="error-text" *ngIf="calleFactCtrl.invalid && (calleFactCtrl.dirty || calleFactCtrl.touched)">
                            <small *ngIf="calleFactCtrl.errors?.['required']">La calle es obligatoria.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="region_fact"><span class="required-asterisk" *ngIf="!request.region_fact|| request.region_fact.trim() === ''">*</span>Región</label>
                        <select class="crm-input" name="region_fact" id="region_fact" [(ngModel)]="request.region_fact" (change)="getComunasFact(request.region_fact)" #regionFactCtrl="ngModel" required>
                            @for(item of regiones; track item.NombreRegion){
                                <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
                            }
                        </select>
                        <div class="error-text" *ngIf="regionFactCtrl.invalid && (regionFactCtrl.dirty || regionFactCtrl.touched)">
                            <small *ngIf="regionFactCtrl.errors?.['required']">La regi&oacute;n es obligatoria.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="ciudad_fact"><span class="required-asterisk" *ngIf="!request.ciudad_fact|| request.ciudad_fact.trim() === ''">*</span>Comuna</label>
                        <select class="crm-input"name="ciudad_fact" id="ciudad_fact" [(ngModel)]="request.ciudad_fact" #ciudadFactCtrl="ngModel" required>
                            @for (comuna of comunasFact; track comuna) {
                                <option [value]="comuna">{{ comuna }}</option>
                            }
                        </select>
                        <div class="error-text" *ngIf="ciudadFactCtrl.invalid && (ciudadFactCtrl.dirty || ciudadFactCtrl.touched)">
                            <small *ngIf="ciudadFactCtrl.errors?.['required']">La comuna es obligatoria.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="pais_fact">País</label>
                        <input class="crm-input" name="pais_fact" type="text" id="pais_fact" [(ngModel)]="request.pais_fact" disabled>
                    </div>
                </div>
                <div>
                    <h5 class="text-semibold mt-4">Dirección de envío</h5>
                    <div class="mt-3">
                        <label class="login-label" for="calle_env"><span class="required-asterisk" *ngIf="!request.calle_env|| request.calle_env.trim() === ''">*</span>Calle:</label>
                        <input class="crm-input" name="calle_env" type="text" id="calle_env" [(ngModel)]="request.calle_env" placeholder="Av. Libertador 1234" #calleEnvCtrl="ngModel" required>
                        <div class="error-text" *ngIf="calleEnvCtrl.invalid && (calleEnvCtrl.dirty || calleEnvCtrl.touched)">
                            <small *ngIf="calleEnvCtrl.errors?.['required']">La calle es obligatoria.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="region_env"><span class="required-asterisk" *ngIf="!request.region_env|| request.region_env.trim() === ''">*</span>Región</label>
                        <select class="crm-input" name="region_env" id="region_env" [(ngModel)]="request.region_env" (change)="getComunasEnv(request.region_env)" #regionEnvCtrl="ngModel" required>
                            @for(item of regiones; track item.NombreRegion){
                                <option [value]="item.NombreRegion">{{item.NombreRegion}}</option>
                            }
                        </select>
                        <div class="error-text" *ngIf="regionEnvCtrl.invalid && (regionEnvCtrl.dirty || regionEnvCtrl.touched)">
                            <small *ngIf="regionEnvCtrl.errors?.['required']">La regi&oacute;n es obligatoria.</small>
                        </div>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="ciudad_env"><span class="required-asterisk" *ngIf="!request.ciudad_env|| request.ciudad_env.trim() === ''">*</span>Comuna</label>
                        <select class="crm-input" name="ciudad_env" id="ciudad_env" [(ngModel)]="request.ciudad_env" required>
                            @for (comuna of comunasEnv; track comuna) {
                                <option [value]="comuna">{{ comuna }}</option>
                            }
                        </select>
                    </div>
                    <div class="mt-3">
                        <label class="login-label" for="pais_env">País</label>
                        <input class="crm-input" name="pais_env" type="text" id="pais_env" [(ngModel)]="request.pais_env" disabled>
                    </div>
                </div>
            </div>

            <hr class="mt-5 mb-5">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button type="button" (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                @if(data.mode === 'edit'){
                    <button type="button" class="btn btn-primary text-center" (click)="updateAccount();" [disabled]="!accountForm.valid">Modificar Cuenta</button>
                }@else{
                    <button type="button" class="btn btn-primary text-center" (click)="createAccount();" [disabled]="!accountForm.valid">A&#241;adir nueva Cuenta</button>
                }
            </div>
            </form>
        </div>
    </div>
</div>
